import React, { useEffect, useState } from "react";
// import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from "@mui/material";
import CustomTable from "../../../Components/Table/CustomTable";
import AllUserTableViewModal from "../../OperatorRegistration/Modal/AllUserTableViewModal";
import AllUserListCreateModal from "../../OperatorRegistration/Modal/AllUserListCreateModal";
import UserCreateByOperatorModal from "../Modal/UserCreateByOperatorModal";
// import AllUserListCreateModal from './Modal/AllUserListCreateModal';
// import AllUserTableViewModal from './Modal/AllUserTableViewModal';
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../ReduxStore/Slices/headerSlice";
import TableDataViewModal from "../Modal/TableDataViewModal";
import actions from "../../../ReduxStore/actions";
// import { setHeaderName } from './headerSlice';

const UserRegistration = ({ setHeaderTitleName }) => {
  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");

   const customerId = useSelector((state) => state.customer);

   console.log(customerId,"customerIdcustomerIdcustomerIdcustomerId");
   

  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );
  const dispatch = useDispatch();
  const { getCustomersByCreator } = useSelector(
    (state) => state?.getCustomersByCreator
  );

console.log(getCustomersByCreator,"getCustomersByCreatorgetCustomersByCreator")

  useEffect(() => {
    const data1 = {
      data: {
        createdByUserId: sessionOperator_id,
        createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getCustomersByCreator",
    };

    dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
  }, [managementRegisterForCustomer]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      CustomerId:"--",
      Email: "--",
      MobileNumber: "--",
      UserType: "--",
      Status: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getCustomersByCreator?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}` || "--",
        customer_id:data?.customer_id || "--",
        Email: data?.email || "--",
        MobileNumber: data?.phone || "--",
        // UserType: data?.role ? data?.role : "--",
        UserType: data?.role ? data?.role?.charAt(0).toUpperCase() + data?.role?.slice(1) : "",

        Status:
          data?.approval_status === "pending"
            ? "Pending"
            : data?.approval_status === "approved"
            ? "Approved"
            : "Unknown" || "--", // Add a default case if needed
            
      });   
    });
    setRowTableData(tempArr);
  }, [dispatch, getCustomersByCreator]);

  
  useEffect(() => {
    dispatch(setHeaderName("User Registration"));
    dispatch(setSubHeaderName(""));
    
  }, []);
  const tableHeadData = [
    "S.No",
    "Name",
    // "Customer Id",
    "Email Id",
    "Mobile Number",
    "User Type",
    "Status",
    "Purchase"
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          purchaseButton="purchaseButton"
          title="User List"
          tableHeadData={tableHeadData}
          modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={TableDataViewModal}
          notModalTable="notModalTable"
          // tableEdit="tableEdit"
          tableView="tableView"
          dataCreate={true}
          modalViewHeadingName="User Detail"
          modalHeadingName="Create User"
        />
      </Grid>
    </Grid>
  );
};

export default UserRegistration;
